import React from "react"

export default ({ src, title}) => {
    return (
        <img className="img-fluid" src={`${process.env.REACT_APP_CDN}/${src}`} alt={title}/>
    );
}
